// Parse the `filename` out of a `Content-Disposition` header value.
//
// Rails 8's `send_file` emits the dual RFC-6266 / RFC-5987 form,
//   Content-Disposition: attachment; filename="X.xlsx"; filename*=UTF-8''X.xlsx
// so a naive `.split('filename=')[1]` grabs the second filename
// parameter too. The 2026-05-20 report ("при скачуванні ексель
// аплікашки невірно формує імʼя файла") was caused by that exact
// shortcut leaking the trailing `; filename*=UTF-8''…` into the
// saved file name on disk (macOS rewrites `*` → `_` because `*`
// is reserved, hence the visible `; filename_=UTF-8''…` suffix).

const RFC_5987_RE = /filename\*\s*=\s*UTF-8''([^;\r\n]+)/i;
const FILENAME_RE = /filename\s*=\s*(?:"([^"]*)"|([^;\r\n]+))/i;

export const parseContentDispositionFilename = (header) => {
  if (!header) return null;

  const utf8 = header.match(RFC_5987_RE);
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      // Malformed percent-encoding — fall through to the ASCII form.
    }
  }

  const ascii = header.match(FILENAME_RE);
  if (ascii) {
    const value = (ascii[1] ?? ascii[2] ?? '').trim();
    return value || null;
  }

  return null;
};
